import { AcceptionFormPage, BaoCaoChamComPage, BaoCaoDiemDanhAnPage, BaoCaoDiemDanhAnQuyetToanPage, ChieuCaoCanNangPage, CuocThaoLuanPage, DanhGiaThuongXuyenHocTapPage, DgTuanNlpcPage, DotDanhGiaLayoutPage, GioCongDongHoatDongDetailPage, HoatDongHangNgayPage, HocSinhDashboardPage, LegalLayoutPage, MaNhanXetPage, ThangDiemPage, ThoiKhoaBieuMamNonPage } from './pages/index';


import {
  AppAccountPage,
  AppMenuTruongConfig, AppXinNghiDetailPage,
  AppXinNghiPage,
  AppYeuCauHoTroDetailPage,
  AppYeuCauHoTroPage,
  BaiTapPage,
  BaiVietComment,
  BaiVietDetailPage,
  BaiVietPage, BaoCaoDiemDanhPage, BaoCaoNhapDiemPage, BaoCaoTienBoPage,
  BaoCaoTienBoReviewLayout,
  ClbNgoaiKhoaDetail,
  ClbNgoaiKhoaLayout,
  ClbNgoaiKhoaRegistedResult,
  ConfigSoDiemTieuHocPage,
  DGDKNLPCPage,
  DanThuocPage,
  DangKyVeMuonForm,
  DangKyVeMuonPage,
  DanhGiaDinhKyHocTapPage,
  DiemDanhHangNgay,
  // DanhGiaThuongXuyenHocTapPage,
  // DanhGiaThuongXuyenNLPCPage,
  DiemDanhHangNgayPage,
  DiemVanMinhKetQuaPage, DiemVanMinhTieuChiPage,
  GanSoDiemPage,
  GanSoNLPCPage, GiaoVienPage, GioCongDongLayoutPage, HocKyPage,
  HomePage,
  // KhoaDanhGiaThuongXuyenPage,
  LoaiPhongHocPage,
  LopBoMonPage,
  LopHanhChinhList,
  LopHanhChinhPage,
  LopMonHocLop,
  MonHocPage,
  NhanXetHangNgayPage,
  // NhanXetHangNgayCommentPage,
  NhapDiemPage,
  PheDuyetDiemVanMinhPage,
  PhongHocPage,
  SoDiemPage,
  SurveyForm,
  SurveyLayout,
  ThoiKhoaBieuConfigPage,
  // ThoiKhoaBieuConfigPage,
  ThoiKhoaBieuImportPage,
  ThoiKhoaBieuViewPage,
  TietPage, ToKhoiPage,
  TuanPage,
  XepHangHocSinhPage,
  YeuCauHoTroGroupPage
} from './pages';
// import BaoCaoDiemDanhAnPage from './pages/bao-cao-diem-danh-an';
// import ThangDiemPage from './pages/thang-diem-page';
// import HoatDongHangNgayPage from './pages/hoat-dong-hang-ngay';

const routes = [
  {
    path: '/home',
    component: HomePage
  },
  {
    path: '/mon-hoc',
    component: MonHocPage
  },
  {
    path: '/giao-vien',
    component: GiaoVienPage
  },
  {
    path: '/to-khoi',
    component: ToKhoiPage
  },
  {
    path: '/lop-hanh-chinh',
    component: LopHanhChinhPage
  },
  {
    path: '/lop-hanh-chinh-list',
    component: LopHanhChinhList
  },
  {
    path: '/lop-bo-mon',
    component: LopBoMonPage
  },
  {
    path: '/lop-mon-hoc',
    component: LopMonHocLop
  },
  {
    path: '/so-tieu-hoc',
    component: ConfigSoDiemTieuHocPage
  },
  // {
  //   path: '/so-diem/:tab?',
  //   component: SoDiemLayout
  // },
  // {
  //   path: '/so-diem',
  //   component: SoDiemPage
  // },
  // {
  //   path: '/loai-phong-hoc/:tab?',
  //   component: LoaiPhongHocWrapper
  // },
  {
    path: '/phong-hoc',
    component: PhongHocPage
  },
  {
    path: '/loai-phong',
    component: LoaiPhongHocPage
  },

  {
    path: '/xem-thoi-khoa-bieu',
    component: ThoiKhoaBieuViewPage
  },
  {
    path: '/thoi-khoa-bieu/view',
    component: ThoiKhoaBieuViewPage
  },

  {
    path: '/thoi-khoa-bieu/:id',
    component: ThoiKhoaBieuImportPage
  },
  {
    path: '/thoi-khoa-bieu-mn/:id',
    component: ThoiKhoaBieuMamNonPage
  },

  {
    path: '/app-menu-config',
    component: AppMenuTruongConfig
  },
  {
    path: '/app-account',
    component: AppAccountPage
  },
  {
    path: '/bai-viet/:tab?',
    component: BaiVietPage
  },
  {
    path: '/bai-viet/detail/:id',
    component: BaiVietDetailPage
  },
  {
    path: '/bai-viet/comment/:id',
    component: BaiVietComment
  },
  {
    path: '/xin-nghi',
    component: AppXinNghiPage
  },
  {
    path: '/xin-nghi/:id',
    component: AppXinNghiDetailPage
  },

  {
    path: '/ve-muon',
    component: DangKyVeMuonPage
  },
  {
    path: '/ve-muon/:id',
    component: DangKyVeMuonForm
  },
  {
    path: '/diem-danh-hang-ngay/:tab?',
    component: DiemDanhHangNgay
  },
  {
    path: '/diem-danh',
    component: DiemDanhHangNgayPage
  },
  {
    path: '/nhan-xet-hang-ngay',
    component: NhanXetHangNgayPage
  },

  // {
  //   path: '/nhan-xet-hang-ngay',
  //   component: NhanXetHangNgayPage
  // },
  // {
  //   path: '/nhan-xet-hang-ngay-comments/:id',
  //   component: NhanXetHangNgayCommentPage
  // },
  {
    path: '/bai-tap',
    component: BaiTapPage
  }, {
    path: '/nhap-diem',
    component: NhapDiemPage
  },
  {
    path: '/tuan',
    component: TuanPage
  },
  {
    path: '/tiet',
    component: TietPage
  },
  {
    path: '/hoc-ky',
    component: HocKyPage
  },
  {
    path: "/gan-so-diem",
    component: GanSoDiemPage
  },
  {
    path: '/diemvanminh-tieuchi',
    component: DiemVanMinhTieuChiPage
  }, {
    path: '/diem-van-minh',
    component: DiemVanMinhKetQuaPage
  },
  {
    path: '/diem-van-minh-phe-duyet',
    component: PheDuyetDiemVanMinhPage
  },
  {
    path: '/gan-so-nlpc',
    component: GanSoNLPCPage
  },

  {
    path: '/danh-gia-dinh-ky',
    component: DanhGiaDinhKyHocTapPage
  },
  {
    path: '/danh-gia-dinh-ky-nlpc',
    component: DGDKNLPCPage
  },
  {
    path: '/danh-gia-tuan-nlpc',
    component: DgTuanNlpcPage
  },

  {
    path: '/danh-gia-thuong-xuyen',
    component: DanhGiaThuongXuyenHocTapPage
  },
  {
    path: '/danh-gia-thuong-xuyen-nlpc',
    component: DgTuanNlpcPage
  },
  // {
  //   path: '/khoa-danh-gia-thuong-xuyen/:tab?',
  //   component: KhoaDanhGiaThuongXuyenPage
  // },
  {
    path: '/bao-cao-tien-bo',
    component: BaoCaoTienBoPage
  },
  {
    path: '/bao-cao-tien-bo-review/:tab?',
    component: BaoCaoTienBoReviewLayout
  },
  // {
  //   path: '/xep-hang-hoc-sinh',
  //   component: XepHangHocSinhPage
  // },
  {
    path: '/xep-hang-hoc-sinh/:tab?',
    component: XepHangHocSinhPage
  },

  {
    path: '/bao-cao-diem-danh',
    component: BaoCaoDiemDanhPage
  },
  {
    path: '/bao-cao-diem-danh-an',
    component: BaoCaoDiemDanhAnPage
  },
  {
    path: '/bao-cao-diem-danh-an-quyet-toan',
    component: BaoCaoDiemDanhAnQuyetToanPage
  },
  {
    path: '/bao-cao-cham-com',
    component: BaoCaoChamComPage
  },
  {
    path: '/yeu-cau-ho-tro',
    component: AppYeuCauHoTroPage
  },
  {
    path: '/yeu-cau-ho-tro-group',
    component: YeuCauHoTroGroupPage
  },
  {
    path: '/yeu-cau-ho-tro/:id',
    component: AppYeuCauHoTroDetailPage
  },
  // {
  //   path: '/student/:id',
  //   component: HocSinhProfilePage
  // },
  {
    path: '/dan-thuoc',
    component: DanThuocPage
  },
  {
    path: '/clb-ngoai-khoa/:tab?',
    component: ClbNgoaiKhoaLayout
  },
  {
    path: '/clb-ngoai-khoa/detail/:id',
    component: ClbNgoaiKhoaDetail
  },
  {
    path: '/clb-ngoai-khoa/:id/result',
    component: ClbNgoaiKhoaRegistedResult
  },
  {
    path: '/survey/form/:id',
    component: SurveyForm
  },
  // {
  //   path: '/survey/form',
  //   component: SurveyFormPage
  // },
  {
    path: '/survey/:tab?',
    component: SurveyLayout
  },
  {
    path: '/thoi-khoa-bieu',
    component: ThoiKhoaBieuConfigPage
  },
  {
    path: '/bao-cao-nhap-diem/:tab?',
    component: BaoCaoNhapDiemPage
  },
  {
    path: '/gio-cong-dong/:tab?',
    component: GioCongDongLayoutPage
  },
  {
    path: '/gio-cong-dong/hoat-dong/:id',
    component: GioCongDongHoatDongDetailPage
  },
  {
    path: '/hoc-sinh/:id',
    component: HocSinhDashboardPage
  },
  {
    path: '/cuoc-thao-luan/:id',
    component: CuocThaoLuanPage
  },
  {
    path: '/legal-document',
    component: LegalLayoutPage
  },
  {
    path: '/chieu-cao-can-nang',
    component: ChieuCaoCanNangPage
  },
  {
    path: '/acception-form',
    component: AcceptionFormPage
  },
  {
    path: '/ma-nhan-xet',
    component: MaNhanXetPage
  },
  {
    path: '/thang-diem',
    component: ThangDiemPage
  },
  {
    path: '/hoat-dong-mam-non',
    component: HoatDongHangNgayPage
  },
  {
    path: "/dot-danh-gia/:tab?",
    component: DotDanhGiaLayoutPage,
  },
  {
    path: '/so-diem',
    component: SoDiemPage
  },

]
export default routes.map(route => {
  return {
    ...route,
    // component: withNavigationWatcher(route.component)
  };
});
